import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface StepTransitionProps {
  children: ReactNode;
}

export default function StepTransition({ children }: StepTransitionProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      {children}
    </motion.div>
  );
}